<div class="dot" *ngFor="let index of numbers" (click)="click(index)" [class.active]="activeDot === index"></div>